export default __webpack_public_path__ + "static/media/bg.9deedbd9.jpg";